module.exports = __webpack_public_path__ + "static/media/odapp-logo-footer.b00a6f36.svg";